export default function SpecialSummaryCards({ specials }) {
  const now = new Date();
  const soon = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
  const counts = specials.reduce((acc, special) => {
    acc.totalRedemptions += Number(special.redemption_count || 0);
    acc[special.status] = (acc[special.status] || 0) + 1;
    if (special.status === "active" && special.ends_at && new Date(special.ends_at) <= soon) acc.expiring += 1;
    return acc;
  }, { active: 0, scheduled: 0, draft: 0, expiring: 0, totalRedemptions: 0 });
  const cards = [
    ["Active Specials", counts.active, "Visible now on the storefront"],
    ["Scheduled", counts.scheduled, "Ready for a future date"],
    ["Expiring Soon", counts.expiring, "Ending within seven days"],
    ["Drafts", counts.draft + (specials.filter((s) => s.status === "disabled").length), "Private or inactive ideas"],
    ["Total Redemptions", counts.totalRedemptions, "Tracked for reporting"],
  ];
  return <section className="special-summary-grid">{cards.map(([label, value, helper]) => <article className="special-summary-card" key={label}><span>{label}</span><strong>{value}</strong><p>{helper}</p></article>)}</section>;
}